export const baseUrl = "https://atci.lkm.accenture.com/lttmicrosite-apis"
// export const baseUrl = "http://localhost:3044"

export const apiURL = process.env.NODE_ENV === 'development' 
                        ? "http://localhost:3044" 
                        : window.location.href.split(".")[2] === "staging"
                        ? "https://atci.abcuniversity.staging.accenture.com/abcuniversitystage-apis"
                        : "https://atci.abcuniversity.accenture.com/abc-university-apis";
